import React from 'react'
import { Global, css } from '@emotion/react'

const GlobalStyles = () => {
  return (
    <Global
      styles={css`
        :root {
          /* global colours */
          --screen-500: #0000fe;
          --screen-400: #2e60ff;
          --screen-300: #8098ff;
          --screen-200: #c1caff;
          --screen-100: #e9ebff;
          --screen-50: #f4f5ff;

          --terminal-500: #2e2b26;
          --terminal-400: #514d46;
          --terminal-300: #737169;
          --terminal-200: #969491;
          --terminal-100: #c7c7c6;
          --terminal-50: #ecebe9;
          --terminal-0: #ffffff;

          --firewall-500: #ff5800;
          --firewall-400: #ff6c00;
          --firewall-300: #ff7f00;
          --firewall-200: #ff8927;
          --firewall-100: #ffad74;
          --firewall-50: #ffd3ba;

          /* global font families */
          --mono-font-stack: ballinger-mono, monospace;
        }

        html {
          box-sizing: border-box;
        }

        *,
        *:before,
        *:after {
          box-sizing: inherit;
        }

        body {
          margin: 0;
          background-color: #ffffff;
          color: #000000;
        }

        .wf-loading h1,
        .wf-loading h2,
        .wf-loading h3 {
          visibility: hidden;
        }
        .wf-active h1 .wf-inactive h1,
        .wf-active h2 .wf-inactive h2,
        .wf-active h3,
        .wf-inactive h3 {
          visibility: visible;
        }
      `}
    />
  )
}

export default GlobalStyles
